import * as React from 'react'
import * as Redux from 'react-redux'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import * as model from '@owl-nest/models'

import { RootState } from '../../../../reducers'
import * as projectModel from '../../../models/project'

export function ComingSoonHeader(): React.ReactElement<unknown> {
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)

  return (
    <Wrapper>
      <Owner href={project.owner.absolute_url}>
        <plume.styles.image.Avatar src={model.user.avatar(project.owner, '90x90')} alt="" />
        <plume.styles.heading.XS>{model.user.username(project.owner)}</plume.styles.heading.XS>
      </Owner>

      <plume.glyphs.stroke.Close size={22} />
      <a href="/">
        <plume.logos.ulule.HorizontalLogo />
      </a>
    </Wrapper>
  )
}

const Owner = styled.a`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
  text-decoration: none;
`

const Wrapper = styled.div`
  align-content: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 16px;
  padding-bottom: 20px;
  padding-top: 26px;

  ${plume.glyphs.stroke.Close} {
    color: ${plume.COLORS.GREY_SHADE_4};
    margin: 0 22px;
  }

  ${plume.styles.heading.XS} {
    margin-left: 6px;
    width: 70%;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    ${plume.styles.heading.XS} {
      margin-left: 6px;
      width: 100%;
    }
  }
`
